<template>
  <div 
    ref="modal_more_filters" 
    id="modal_more_filters" 
    class="modal modal-right fade modal-more-filters" 
    tabindex="-1"
  >
    <div 
      class="modal-dialog" 
      style="width: 360px;"
    >
      <div 
        class="modal-content"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">{{$t('More Filters')}}</h6>
          <button 
            @click="$emit('close')" 
            ref="onClose" 
            type="button" 
            class="close" 
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <!-- start Carrier - shipping_method -->
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('shipping_method')"
                name="shipping_method"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-shipping_method"
              >
                <div>{{ $t("Carrier") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': options.shipping_method}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body px-4 show"
              id="collapse-shipping_method"
            >
              <div class="filter-option">
                <div
                  class="form-group text-grey-400"
                  :class="{'mb-0': !shippingMethod}"
                >
                  <div
                    class="form-check"
                    v-for="shipping_method in shippingMethod"
                    :key="shipping_method.id"
                  >
                    <label class="form-check-label">
                      <div class="uniform-checker">
                        <span :class="[(dataFilter.shipping_method.includes(shipping_method.id) ? 'checked' : '')]">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="shipping_method.id"
                            :id="'advance_shipping_method-'+shipping_method.id"
                            v-model="dataFilter.shipping_method"
                            disabled
                          >
                        </span>
                      </div>
                      <img
                        :src="shipping_method.logo"
                        class="mr-2 rounded"
                        width="20"
                        height="20"
                      >
                      {{ $t(shipping_method.name) }}
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('shipping_method')"
                    disabled
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>

          <!--  start shipment_status -->
          <div class="card card-collapsed border-0 shadow-none mb-0">
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('shipment_status')"
                name="shipment_status"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-shipment_status"
              >
                <div>{{ $t("Shipment Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': options.shipment_status}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body px-4 show"
              id="collapse-shipment_status"
            >
              <div class="filter-option">
                <div
                  class="form-group text-grey-400"
                  :class="{'mb-0': !shipmentStatus}"
                >
                  <div
                    class="form-check"
                    v-for="(shipment_status, key) in shipmentStatus"
                    :key="key"
                  >
                    <label class="form-check-label">
                      <div class="uniform-choice">
                        <span :class="[(dataFilter.shipment_status === shipment_status ? 'checked' : '')]">
                          <input
                            type="radio"
                            name="adv_shipment_status_filter"
                            :id="`${key}-${shipment_status}`"
                            :value="shipment_status"
                            v-model="dataFilter.shipment_status"
                            disabled
                          >
                        </span>
                      </div>
                      {{ $t(shipment_status) }}
                    </label>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('shipment_status')"
                    disabled
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShippingExpensesDetailFiltersMore',
  props:{
    shipmentStatus: {
      type: [Array],
      default: null
    },
    shippingMethod: {
      type: [Array],
      default: null
    }
  },
  data() {
    return {
      dataFilter: initialFilter(),
      options: {
        shipment_status: true,
        shipping_method: true
      },
    }
  },
  async created() {
    if (this.$route.query.shipment_status) {
      this.dataFilter.shipment_status = this.$route.query.shipment_status
    }
    if (this.$route.query.shipping_method_ids) {
      let shippingMethodIds = typeof this.$route.query.shipping_method_ids == 'string' ? [this.$route.query.shipping_method_ids] : this.$route.query.shipping_method_ids
      this.dataFilter.shipping_method = shippingMethodIds.map(i => Number(i))
    }
  },
  mounted() {
    $("#modal_more_filters").modal('show')
  },
  methods: {
    toggleOption(key) {
      if (key == 'shipment_status') {
        (this.options.shipment_status) ? this.options.shipment_status = false: this.options.shipment_status = true;
      } else if (key == 'shipping_method') {
        (this.options.shipping_method) ? this.options.shipping_method = false: this.options.shipping_method = true;
      }
    },
    clearFilter(key) {
      if (key == 'shipment_status') {
        this.dataFilter.shipment_status = "";
      } else if (key == 'shipping_method') {
        this.dataFilter.shipping_method = [];
      } else if (key == 'all') {
        this.dataFilter = initialFilter();
      }
    },
  }
}

function initialFilter() {
  return {
    shipment_status: "",
    shipping_method: [],
  }
}
</script>
<style scoped>
  .uniform-checker span {
    color: #888 !important;
    border: 0.125rem solid #888 !important;
  }
  .uniform-choice span {
    color: #888 !important;
    border: 0.125rem solid #888 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/ShippingExpensesDetailTableFiltersMore.vue